<template>
  <tela-component title="Resumo Médias de Descontos/Comissões/Prazo de Vendas">
    <v-card flat rounded="lg">
      <v-card-text>
        <v-row>
          <v-col xl="auto" lg="auto" md="auto" cols="12">
            <v-select
              label="Mês"
              :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
              v-model="filtro.mes"
            ></v-select>
          </v-col>
          <v-col xl="auto" lg="auto" md="auto" cols="12">
            <v-text-field label="Ano" v-model="filtro.ano"></v-text-field>
          </v-col>
          <v-col xl="auto" lg="auto" md="auto" cols="12">
            <!-- Radio Buttons para selecionar o tipo de relatório -->
            <v-radio-group v-model="filtro.tipoRelatorio" :row="isNotMobile">
              <v-radio :value="1" label="COM Comissão"></v-radio>
              <v-radio :value="2" label="SEM Comissão"></v-radio>
              <v-radio :value="3" label="AMBOS"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col xl="auto" lg="auto" md="auto" cols="12" align-self="center">
            <v-btn
              rounded
              depressed
              color="info"
              @click="gerarRelatorio()"
              :loading="gerandoRelat"
              >Gerar relatório</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </tela-component>
</template>

<script>
import moment from "moment";
import TelaComponent from "../tela/TelaComponent.vue";
import axios from "axios";
import fileDownload from "js-file-download";

export default {
  components: { TelaComponent },
  data: () => ({
    filtro: {
      mes: 0,
      ano: 0,
      output: "pdf",
      tipoRelatorio: 3,
    },
    gerandoRelat: false,
    isNotMobile: true,
  }),
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    async gerarRelatorio() {
      this.gerandoRelat = true;
      this.filtro.tipoRelatorio = parseInt(this.filtro.tipoRelatorio, 10);

      await axios
        .get("/nutricao-animal/relatorios/medias-vendedor", {
          responseType: "blob",
          params: this.filtro,
        })
        .then((res) => {
          fileDownload(res.data, "resumo-medias.pdf");
        })
        .catch((e) => this.$toasted.error(e));
      this.gerandoRelat = false;
    },
    checkScreenSize() {
      // Checks if the inner width of the window is less than 600 pixels
      this.isNotMobile = window.innerWidth > 600;
    },
  },
  created() {
    this.filtro.mes = moment().month() + 1;
    this.filtro.ano = moment().year();
    this.tipoRelatorio = 3;
  },
};
</script>

<style></style>
